import { useState, useEffect, useMemo } from "react";
import axios from 'axios'
import styled from "styled-components";
import { IoMdArrowBack } from "react-icons/io";



import Geral from "./Grid-boletin-cct.js";
import Frentes from "./Grid-boletin-frentes.js";
import Qualidade from "./Grid-boletin-qualidade.js";
import Produção from "./Grid-boletin-producao.js";
import Produtividade from "./Grid-boletin-produtividade.js"
import EntradaPorHora from "./Grid-boletin-entrada-cana-por-hora.js";
import CanaManual from "./Grid-boletin-cana-manual.js";
import Industria from "./Grid-boletin-industria.js";
import Milho from "./Grid-boletin-milho.js";
import Mercado from "./Grid-boletin-mercado.js";


import logo1 from "./logo-1.png";
import logo2 from "./logo-2.png";
import logo3 from "./logo-3.png";
import logo4 from "./logo-4.png";
import logo5 from "./logo-5.png";

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  
`;


const TabsSelect = styled.select`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-weight: bold;

  @media (min-width: 780px) {
    display: none; 

  }
`;

const TabsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;          /* 👈 não deixa quebrar linha */
  gap: 10px;
  justify-content: center;    /* ou: flex-start, se preferir à esquerda */
  align-items: center;

  overflow-x: auto;           /* 👈 habilita rolagem quando não couber */
  -webkit-overflow-scrolling: touch;
  padding: 8px 0;

  width: 100%;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 779px) {
    display: none;            /* no mobile você já usa o <select> */
  }
`;








const Imagem = styled.img`
  width: 600px;
  height: auto;

  @media (max-width: 768px) {
    width: 200px;
    height: auto;
  }
`;


export const TabButton = styled.button`
  flex: 0 0 auto;             /* 👈 impede de crescer/encolher */
  white-space: nowrap;        /* 👈 não quebra o label em 2 linhas */
  padding: 10px 20px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: ${({ active }) => (active ? "#0a7a3f" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  cursor: pointer;
  transition: all .2s ease;


  &:focus { outline: none; box-shadow: 0 0 0 2px #076333; }
`;









// seu ButtonSair pode ser o existente; exemplo de estilo:
const ButtonSair = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px; height: 36px;
  border: 0; border-radius: 8px;
  background: #fff; cursor: pointer;
  transition: background .15s;
  
`;

const Grid = ({ urlApi, zoomIn, zoomOut, zoom }) => {

  const urlFront = process.env.REACT_APP_FRONT_URL;

  const [abaAtiva, setAbaAtiva] = useState("CCT");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];


  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000); // 1.0 segundos de exibição
  };



  //Retorna os periodos para o cabeçalho

  const [periodos, setPeriodos] = useState("")

  useEffect(() => {
    const fetchPeriodos = async () => {
      const res = await axios.get(`${urlApi}boletins-externo/periodos`);
      setPeriodos(res.data);
    };

    fetchPeriodos();
  }, []);



  const handleVoltarDash = () => {
    window.location.href = urlFront;
  };




  return (

    <Div>
      <>
        <>

          <TabsContainer>
            <ButtonSair onClick={handleVoltarDash} title="Voltar" aria-label="Voltar ao dashboard">
              <IoMdArrowBack size={20} />
            </ButtonSair>

            <TabButton active={abaAtiva === "CCT"} onClick={() => trocarAbaComImagem("CCT")}>CCT</TabButton>
            <TabButton active={abaAtiva === "frentes"} onClick={() => trocarAbaComImagem("frentes")}>Frentes</TabButton>
            <TabButton active={abaAtiva === "qualidade"} onClick={() => trocarAbaComImagem("qualidade")}>Qualidade</TabButton>
            <TabButton active={abaAtiva === "produtividade"} onClick={() => trocarAbaComImagem("produtividade")}>Produtividade</TabButton>
            <TabButton active={abaAtiva === "producao"} onClick={() => trocarAbaComImagem("producao")}>Produção</TabButton>
            <TabButton active={abaAtiva === "entrada-por-hora"} onClick={() => trocarAbaComImagem("entrada-por-hora")}>Entrada de Cana por Hora</TabButton>
            <TabButton active={abaAtiva === "cana-manual"} onClick={() => trocarAbaComImagem("cana-manual")}>Cana Manual</TabButton>
            <TabButton active={abaAtiva === "industria"} onClick={() => trocarAbaComImagem("industria")}>Cana</TabButton>
            <TabButton active={abaAtiva === "milho"} onClick={() => trocarAbaComImagem("milho")}>Milho</TabButton>
            <TabButton active={abaAtiva === "mercado"} onClick={() => trocarAbaComImagem("mercado")}>Mercado</TabButton>


          </TabsContainer>


          {/* Versão para mobile */}
          <TabsSelect value={abaAtiva} onChange={(e) => trocarAbaComImagem(e.target.value)}>

            <option value="CCT">CCT</option>
            <option value="frentes">Frentes</option>
            <option value="qualidade">Qualidade</option>
            <option value="produtividade">Produtividade</option>
            <option value="producao">Produção</option>
            <option value="entrada-por-hora">Entrada de Cana por Hora</option>
            <option value="cana-manual">Cana Manual</option>
            <option value="industria">Cana</option>
            <option value="milho">Milho</option>
            <option value="mercado">Mercado</option>
          </TabsSelect>
        </>



        {loadingImage ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "82vh",           // altura total da tela
            width: "100%",
            textAlign: "center"
          }}>
            <Imagem
              src={loadingImage}
              alt="Carregando..."
              style={{
                animation: "zoomIn 0.8s ease-out forwards"
              }}
            />

            <style>
              {`
    @keyframes zoomIn {
      from {
        opacity: 0;
        transform: scale(0.8);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  `}
            </style>
          </div>
        ) : (
          <>
            {abaAtiva === "CCT" && <Geral urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} zoom={zoom} />}
            {abaAtiva === "frentes" && <Frentes urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "qualidade" && <Qualidade urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "produtividade" && <Produtividade urlApi={urlApi} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "producao" && <Produção urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "entrada-por-hora" && <EntradaPorHora urlApi={urlApi} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "cana-manual" && <CanaManual urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "industria" && <Industria urlApi={urlApi} periodos={periodos} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "milho" && <Milho urlApi={urlApi} zoomIn={zoomIn} zoomOut={zoomOut} />}
            {abaAtiva === "mercado" && <Mercado />}
          </>
        )}
      </>


    </Div>

  );
};



export default Grid;
